module.exports = __webpack_public_path__ + "assets/img/lSlive2.e357962b.png";